import Checkbox from '@/component/Checkbox';
import { useDataProvider } from '@/component/Table/DataProviderContext';
import type { Row as TRow, RowData } from '@tanstack/react-table';
import { flexRender } from '@tanstack/react-table';
import { BodyCell } from '../../components/BodyCell';
import { TableRow } from '../../components/TableRow';

interface RowProps<TData extends RowData> {
  row: TRow<TData>;
  isHighlight?: boolean;
  isClickable?: boolean;
  onClick?: (row: TRow<TData>) => void;
}

export const Row = <TData extends RowData>({
  row,
  isClickable = false,
  isHighlight = false,
  onClick,
}: RowProps<TData>) => {
  const { table } = useDataProvider();
  const enableRowSelection = Boolean(table?.options.enableRowSelection);

  return (
    <TableRow
      isClickable={isClickable}
      isHighlight={isHighlight}
      onClick={() => onClick?.(row)}
    >
      {enableRowSelection && (
        <BodyCell padding="checkbox">
          <Checkbox
            name="select-row"
            checked={row.getIsSelected()}
            onChange={() => row.toggleSelected()}
            onClick={(e) => e.stopPropagation()}
          />
        </BodyCell>
      )}
      {row.getVisibleCells().map((cell) => {
        return (
          <BodyCell
            key={cell.id}
            // @ts-ignore
            padding={cell.column.columnDef.cellPadding}
          >
            {cell.getIsPlaceholder()
              ? null
              : flexRender(cell.column.columnDef.cell, cell.getContext())}
          </BodyCell>
        );
      })}
    </TableRow>
  );
};
